module.exports = __webpack_public_path__ + "img/verification-gray.fd62f9cc.png";